module.exports = __webpack_public_path__ + "static/media/car-marker-waiting.8eee9904.png";